import React, { useState, useCallback } from "react";
import { connect } from "react-redux";
import { View, Text } from "react-native";
import CustomButton from "../../../commonComponents/CustomButton";
import { globalFontStyle } from "../../../assets";
import { globalImport } from "../../../common/globalImports";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {globalConfigurableData} from "../../../utils/globalConstant";
import Gradient from "../../../commonComponents/Gradient";

const HowItWorksRewards = ({ onLearnMore, httData }) => {

    return (
        <View style={{ paddingTop: 15, paddingBottom: 20, paddingHorizontal: 16 }}>
            <FormTextLabel
                labelStyles={[
                    {
                        ...globalFontStyle.appFontTitle,
                        color: globalConfigurableData.primaryTextColor1,
                    },
                ]}
                label={httData?.title}
            />
            <FormTextLabel
                labelStyles={[
                    {
                        ...globalFontStyle.appFontHeadingRegular,
                        color: globalConfigurableData.primaryTextColor1,
                        marginVertical: 10,

                    },
                ]}
                label={httData?.description}
            />
            <FormTextLabel
                labelStyles={[
                    {
                        ...globalFontStyle.appFontBody,
                        color: globalConfigurableData.primaryTextColor1,

                    },
                ]}
                label={"Example"}
            />
            <Gradient
                colors={['#CA2C92', '#5037BF']}
                // locations={[0.017, 0.65]}
                end={{x: 0.1, y: 0.4}}
                style={{
                    borderRadius: 8,
                    backgroundColor: "#F9F9F9",
                    borderColor: "#CFCFCF",
                    borderWidth: 0.75,
                    marginBottom: 20,
                    marginTop: 15
                }}>
                <View style={{
                    margin: 1,
                    borderRadius: 8,
                    backgroundColor: globalConfigurableData.globalThemeColor
                }}>
                    {httData?.meta?.map((item, index) => {
                        return (
                            <View
                                key={index}
                                style={[
                                    {
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        paddingHorizontal: 11,
                                        marginHorizontal: 8,
                                        paddingVertical: 12,
                                        borderTopWidth: 0.75,
                                        borderColor: globalConfigurableData.borderColor,
                                        backgroundColor: globalConfigurableData.globalThemeColor
                                    },
                                ]}
                            >
                                <Text
                                    style={{
                                        ...globalFontStyle.appFontBody,
                                        color: globalConfigurableData.primaryTextColor1,
                                    }}
                                >
                                    {item.label}
                                </Text>
                                <Text style={{
                                    ...globalFontStyle.appFontSubHeading,
                                    color: globalConfigurableData.primaryTextColor1,
                                }}>{item.value}</Text>
                            </View>
                        );
                    })}
                </View>
            </Gradient>
            <CustomButton
                btnText={"Okay"}
                btnType={"btnBlack"}
                onBtnClick={onLearnMore}
                customStyle={{ flex: globalImport.isWeb ? {} : 0 }}
                translate={true}
            />
        </View>
    );
};

export default connect(null, null)(HowItWorksRewards);
